module.exports = __webpack_public_path__ + "static/img/sdgs_figure.f8633ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sdgs_figure.png
// module id = yoHD
// module chunks = 0